import React, {useRef} from 'react';
import {BrowserRouter} from 'react-router';
import {createRoot} from 'react-dom/client';
import LearningWrapper from '@/app/LearningWrapper';
import EnvironmentProvider from '@sdb/ui/components/providers/Environment/Environment.provider';
import '@/app/aca-app';
import type {AcaAppElement} from '@/shared/types/AcaAppElement';

import {useUserSettings} from '@/shared/hooks/useUserSettings.hook';

// Create a React functional component to handle the logic
const App: React.FC = () => {
    const litRef = useRef<AcaAppElement | null>(null);

    const {data: userSettingsData} = useUserSettings();
    const menu = userSettingsData?.menu;

    return (
        <EnvironmentProvider appName="learning">
            <BrowserRouter>
                <LearningWrapper litRef={litRef}>
                    <aca-app
                        ref={litRef}
                        menu={menu}
                    ></aca-app>
                </LearningWrapper>
            </BrowserRouter>
        </EnvironmentProvider>
    );
};

// Store the initial value (likely null/undefined)
let announcekitValue = window.announcekit;

// Define a custom property descriptor for window.announcekit
Object.defineProperty(window, 'announcekit', {
    get: function () {
        return announcekitValue;
    },
    set: function (newValue) {
        const originalPush = newValue.push;
        newValue.push = function (...args: {boosters?: boolean}[]) {
            if (args[0].boosters === false) {
                args[0].boosters = true;
            }
            return originalPush.apply(newValue, args);
        };

        // Store the (possibly modified) value
        announcekitValue = newValue;

        // You could also trigger other actions here
        // For example, call a function that does something with the new announcekit object
    },
    configurable: true,
});

// Find the root container and render the App component
const container = document.getElementById('root') as HTMLElement | null;

if (container) {
    const root = createRoot(container);

    root.render(<App />);
} else {
    console.error('Root element not found');
}
